import React, { useEffect, useState } from 'react';
import { RotateCcw, AlertTriangle } from 'lucide-react';
import { useSecretaryStore } from '../store/secretaryStore';

export function LimboBanner() {
  const { undoLimbo, deshacerLimbo } = useSecretaryStore();
  const [timeLeft, setTimeLeft] = useState(7000);

  useEffect(() => {
    if (!undoLimbo) {
      setTimeLeft(7000);
      return;
    }

    const interval = setInterval(() => {
      const remaining = Math.max(0, undoLimbo.expiresAt - Date.now());
      setTimeLeft(remaining);
      if (remaining === 0) {
        clearInterval(interval);
      }
    }, 50); // High refresh rate for smooth animation

    return () => clearInterval(interval);
  }, [undoLimbo]);

  if (!undoLimbo) return null;

  const progressPercentage = (timeLeft / 7000) * 100;

  return (
    <div 
      className="absolute bottom-6 left-1/2 -translate-x-1/2 z-999 flex flex-col items-center animate-in slide-in-from-bottom-10 fade-in duration-300"
      style={{ width: 'max-content', maxWidth: '90vw' }}
    >
      <div className="bg-slate-900 text-slate-50 rounded-xl shadow-2xl overflow-hidden w-full border border-slate-700/50 flex flex-col">
        {/* Content */}
        <div className="flex items-center justify-between p-3 px-4 gap-4">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="bg-amber-500/20 p-1.5 rounded-full shrink-0">
              <AlertTriangle className="h-4 w-4 text-amber-500" />
            </div>
            <div className="flex flex-col min-w-0 truncate">
              <span className="font-bold text-xs tracking-wide truncate">
                Cambio Pendiente
              </span>
              <span className="text-slate-300 text-xs truncate">
                {undoLimbo.message}
              </span>
            </div>
          </div>

          <button
            onClick={deshacerLimbo}
            className="flex items-center gap-1.5 bg-slate-800 hover:bg-slate-700 text-slate-200 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors cursor-pointer border border-slate-700 hover:border-slate-600 shrink-0"
          >
            <RotateCcw className="h-3.5 w-3.5 group-hover:-rotate-90 transition-transform duration-300" />
            DESHACER
          </button>
        </div>

        {/* Progress Bar Container */}
        <div className="h-1.5 w-full bg-slate-800">
          {/* Progress Bar Fill */}
          <div 
            className="h-full bg-amber-500 transition-all ease-linear"
            style={{ width: `${progressPercentage}%`, transitionDuration: '50ms' }}
          />
        </div>
      </div>
    </div>
  );
}
